<template>
  <div>
    <user-add user-title="图片列表" user-add-url="/user/pic_info/add"></user-add>
    <el-table :data="Cdata"  class="item-table" height="80vh">
      <el-table-column label="预览" width="100" fixed="left">
        <template slot-scope="scope">
          <el-image class="item-image" :src="'http://'+Cdata[scope.$index].address" alt=""></el-image>
        </template>
      </el-table-column>
      <el-table-column label="id"  prop="id" width="60"></el-table-column>
      <el-table-column label="图片地址" prop="address" width="360"></el-table-column>
      <el-table-column label="文字描述" width="240">
        <template slot-scope="scope">
          <span class="description" :title="Cdata[scope.$index].description">{{Cdata[scope.$index].description}}</span>
        </template>
      </el-table-column>
      <el-table-column label="所属类型" prop="typeStr" ></el-table-column>
      <el-table-column label="是否首页显示"  >
        <template slot-scope="scope">
          <span>{{Cdata[scope.$index].isHomeShow | B}}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" ></el-table-column>
      <el-table-column label="更新时间" prop="updateTime" ></el-table-column>
      <el-table-column label="操作" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleLook(Cdata[scope.$index].id)">查看</el-button>
          <el-button type="text" size="small" @click="handleChange(Cdata[scope.$index].id)">修改</el-button>
          <el-button type="text" size="small" @click="handleDelete(Cdata[scope.$index].id)">删除</el-button>
        </template>
      </el-table-column >
    </el-table>
    <el-pagination
      background
      class="page"
      :page-size="1"
      style="margin-top:15px;"
      @current-change="handleCurrentChange"
      :total="Cpage"
      layout="prev, pager, next"
    > </el-pagination>
  </div>
</template>

<script>
  import UserAdd from "../Common/UserAdd";
  export default {
    name: "PicInfoBase",
    components: {UserAdd},
    data(){
      return{
        Cdata:null,//当前表格展示数据
        Cpage:null,//当前获取数据总页数
        PostData:{
          'pageNumber':0,
          'pageSize':10,
        }
      }
    },
    filters:{
      B(value){
        if (value == true){
          return '是'
        }  else {
          return '否'
        }
      }
    },
    created() {
      this.GetData(this.PostData)
    },
    methods:{
      GetData(PageData){
        this.$axios.post('/api/photo/getAll',PageData).then(res=>{

          this.Cdata=res.data.data.records
          this.Cpage=res.data.data.pages
        })
      },
      handleCurrentChange(index){
        this.PostData.pageNumber=index;
        this.GetData(this.PostData)
      },

      TypeChange(index,code){
        this.TypeId=index;
        this.PostData.type=code
        this.GetData(this.PostData)
      },
      handleLook(id){
        this.$router.push('/user/pic_info/look'+id)
      },
      handleChange(id){
        this.$router.push('/user/pic_info/change'+id)
      },
      Delete(id){
        this.$axios.delete('/api/photo/deleteById',{params:{
          id:id
          }}).then(res=>{
          this.GetData(this.PostData)
        })
      },
      handleDelete(id){
        this.$confirm('确定删除该条信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.Delete(id)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    }
  }
</script>

<style scoped>
.description{
    width: 300px;
    height: 50px;
    white-space: nowrap;
    overflow: hidden;

  }
</style>